import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'footerTrunc',
  standalone: false
})
export class FooterTruncPipe implements PipeTransform {

  transform(value: string): string {
    value = value.trim();
    if (value === 'ניהול רשימת מועדפים') {
      return 'מועדפים';
    }
    if (value === 'צרפו אותי למועדפים') {
      return 'צרפו אותי';
    }
    return value;
  }

}
